// removed by extract-text-webpack-plugin
module.exports = {"loading":"_1m5kt-ValcTpum4xB6WR5Y"};


//////////////////
// WEBPACK FOOTER
// ./src/layouts/routes/AuthorizedRoute.mod.css
// module id = 1573
// module chunks = 0